interface WithId {
    id?: number;
    sort?: number;
}

function upgradeStore(dbReq: IDBOpenDBRequest, store: string) {
    return () => {
        const db = dbReq.result;
        const objectStore = db.createObjectStore(store, {keyPath: 'id'});
        objectStore.createIndex('id', 'id', {unique: false});
    };
}

export async function getFromDatabase<T>(store: string): Promise<T | null> {
    let db!: IDBDatabase;
    const databaseName = 'occasions';
    return new Promise(function (resolve, reject) {
        const dbReq = indexedDB.open(databaseName, 1);
        dbReq.onupgradeneeded = upgradeStore(dbReq, store);
        dbReq.onsuccess = function () {
            db = dbReq.result;
            if ([...db.objectStoreNames].find((name) => name === store)) {
                const transaction = db.transaction(store);
                const objectStore = transaction.objectStore(store);
                const getRequest = objectStore.getAll();
                getRequest.onerror = () => reject(getRequest.error);
                getRequest.onsuccess = () => resolve(getRequest.result as T);
                transaction.oncomplete = () => db.close();
            } else {
                indexedDB.deleteDatabase(store);
                resolve(null);
            }
        };
        dbReq.onerror = function (event) {
            console.error(`IndexedDB error: ${dbReq.error}`, event);
            reject(`IndexedDB error: ${dbReq.error}`);
        };
    });
}

export async function storeArrayInDatabase<T extends WithId>(store: string, values: T[]) {
    return new Promise<void>((resolve, reject) => {
        const request = indexedDB.open('occasions', 1);
        request.onerror = (err) => {
            console.error(`IndexedDB error: ${request.error}`, err);
            reject(request.error);
        };
        request.onupgradeneeded = upgradeStore(request, store);
        request.onsuccess = () => {
            const db = request.result;
            if (![...db.objectStoreNames].find((name) => name === store)) {
                db.close();
                resolve();
                return;
            }
            const transaction = db.transaction(store, 'readwrite');
            const objectStore = transaction.objectStore(store);
            const clearRequest = objectStore.clear();
            clearRequest.onerror = () => reject(clearRequest.error);
            clearRequest.onsuccess = () => {
                let index = 1;
                for (const value of values) {
                    objectStore.put({...JSON.parse(JSON.stringify(value)), sort: index++});
                }
            };
            transaction.oncomplete = () => {
                db.close();
                resolve();
            };
            transaction.onerror = () => reject(transaction.error);
        };
    });
}
